// CLARTEXT SPRACHE – Bulgarische Mitarbeiter-UI (AP-LANG-BG, Juni 2026).
// Echte bulgarische Übersetzung der Monteur-App-UI (KEIN Re-Export mehr von de.js).
// Kyrillische Schrift, vollständig UTF-8 kodiert. Letzte geplante Sprache.
// Schlüssel-IDENTISCH zu de.js; fehlende Schlüssel fallen über createT auf Deutsch
// zurück. Weltinhalte (Welt-Titel, Fragen, Antwortoptionen, GBU-/BA-Texte) sind
// Daten und kommen über den Read-Resolver (`display`), NICHT aus dieser Datei.
const bg = {
  // Gemeinsame
  "common.loading": "Зареждане…",

  // PIN-Login (/monteur/login)
  "login.eyebrow": "Вход",
  "login.title": "Вашият PIN код",
  "login.subtitle": "Код на фирмата + 4-цифрен PIN код от вашия ръководител.",
  "login.companyCodeLabel": "Код на фирмата",
  "login.companyCodePlaceholder": "напр. LUMPE",
  "login.submitting": "Влизане…",
  "login.backAria": "Назад към входа",
  "login.errorNoCode": "Моля, първо въведете кода на фирмата.",
  "login.errorUnknown": "Фирмата или PIN кодът са неизвестни.",

  // Aufgabenliste (/monteur)
  "tasks.companyFallback": "Вашата фирма",
  "tasks.portalSubtitle": "Портал за обучение",
  "tasks.loggedInAs": "Влезли сте като",
  "tasks.heading": "Вашите задачи",
  "tasks.openCount": "{count} отворени",
  "tasks.emptyToday": "Днес няма отворени задачи.",
  "tasks.newBanner": "Имате {count} нови инструктажа от последното ви посещение.",
  "tasks.newBadge": "Ново",
  "tasks.newBannerDismissAria": "Затвори известието",
  "tasks.backAria": "Назад към прегледа",
  "home.tasksTitle": "Инструктажи",
  "home.searchTitle": "Справочник",
  "home.searchSubtitle": "Бърза справка за безопасност",
  "home.hspTitle": "План за защита на кожата",
  "home.hspSubtitle": "Защита на кожата и избор на ръкавици",
  "home.driverTitle": "Проверка на шофьорска книжка",
  "home.driverOpen": "Моля, изпратете шофьорската си книжка",
  "home.driverSubmitted": "Изчаква проверка от фирмата",
  "home.driverUpToDate": "Валидно към момента",
  "home.settingsTitle": "Настройки",
  "home.settingsSubtitle": "Управление на имейл и език",
  "home.comingSoon": "Очаквайте скоро",
  "home.newBubbleAria": "{count} нови инструктажа",
  "settings.profileTitle": "Профил",
  "settings.profileHint": "Името и фирмата се поддържат от фирмата.",
  "settings.emailTitle": "Имейл за известия",
  "settings.emailPurpose": "Използва се единствено за информиране за нови инструктажи.",
  "settings.emailPlaceholder": "ime@primer.bg",
  "settings.emailSave": "Запази",
  "settings.emailSaved": "Запазено",
  "settings.emailInvalid": "Моля, въведете валиден имейл адрес.",
  "settings.emailRemoveHint": "Изчистете полето и запазете, за да се отпишете.",
  "settings.saveError": "Записът не бе успешен. Опитайте отново.",
  "settings.privacyLink": "Политика за поверителност",
  "settings.consentLabel": "Искам да получавам известия по имейл за нови инструктажи.",
  "settings.languageTitle": "Език",
  "settings.langNotBooked": "Сивите езици все още не са заявени от вашата фирма. Говорете с шефа си, ако искате да използвате някой от тях.",
  "tasks.quickLookup": "Бързо търсене",
  "tasks.doneHeading": "Изпълнени",
  "tasks.dueLabel": "Срок",
  "tasks.doneAtLabel": "Изпълнено на",
  "tasks.logoutAria": "Изход",

  // Aufgabendetail (/monteur/aufgabe/:id)
  "aufgabe.notFound": "Задачата не е намерена.",
  "aufgabe.wrongOne":
    "Един отговор беше неправилен. Моля, отговорете отново.",
  "aufgabe.wrongMany":
    "{count} отговора бяха неправилни. Моля, отговорете отново.",
  "aufgabe.saveFailed": "Запазването е неуспешно. Моля, опитайте отново.",
  "aufgabe.doneTitle": "Готово!",
  "aufgabe.doneBody":
    "Обучението „{title}“ е завършено. Вашият документ за потвърждение е създаден автоматично и се съхранява в контролната папка на вашата фирма.",
  "aufgabe.backToTasks": "Назад към моите задачи",
  "aufgabe.stepContent": "Съдържание",
  "aufgabe.stepQuestion": "Въпрос {current} от {total}",
  "aufgabe.backShort": "Задачи",
  "aufgabe.readCalm": "Моля, прочетете внимателно.",
  "aufgabe.questionsFollow": "След това следват {count} кратки въпроса за проверка.",
  "aufgabe.questionLabel": "Въпрос за проверка {current} / {total}",
  "aufgabe.wrongAgain":
    "Този отговор беше неправилен последния път. Моля, изберете отново.",
  "aufgabe.prev": "Назад",
  "aufgabe.saving": "Запазване…",
  "aufgabe.finish": "Завърши обучението",
  "aufgabe.toQuestions": "Към въпросите",
  "aufgabe.next": "Напред",

  // Nachschlage-Suche (Komponente MonteurWeltSuche)
  "suche.placeholder": "Търсене – напр. „акумулатор“, „очила“, „стълба“…",
  "suche.inputAria": "Търсене в документацията",
  "suche.matchIn": "Съвпадение в {label}:",
  "suche.empty": "Не е намерена подходяща документация.",
  "suche.emptyHint": "Опитайте друга дума, напр. „ЛПС“ или „превръзка“.",

  // Welt-Nachschlagewerk (/monteur/welt/:id) – NUR UI-Rahmen/Labels.
  "welt.headerTitle": "Търсене",
  "welt.backAria": "Назад",
  "welt.errorNotAvailable": "Тази документация в момента не е налична.",
  "welt.errorLoad": "Светът не можа да се зареди.",
  "welt.backToTasks": "Назад към моите задачи",
  "welt.loading": "Зареждане на света…",
  "welt.doctype": "Справочник",
  "welt.versionLabel": "Версия",
  "welt.gbuTitle": "Оценка на риска",
  "welt.noHazards": "Няма документирани отделни опасности.",
  "welt.residualRisk": "Остатъчен риск:",
  "welt.measureTechnical": "Технически",
  "welt.measureOrganizational": "Организационни",
  "welt.measurePersonal": "Лични",
  "welt.responsible": "Отговорник:",
  "welt.baTitle": "Инструкция за експлоатация",
  "welt.baSubtitle": "Съгласно TRBS / GefStoffV / BetrSichV",
  "welt.mainHazards": "Основни опасности",
  "welt.protectiveMeasures": "Защитни мерки и правила за поведение",
  "welt.emergency": "При спешен случай",
  "welt.firstAid": "Първа помощ",
  "welt.disposalHazmat": "Съхранение и изхвърляне",
  "welt.disposalVehicle": "Паркиране",
  "welt.disposalDefault": "Извеждане от експлоатация",
  "welt.instructionTitle": "Обучение",
  "welt.instructionSubtitle": "Съгласно DGUV V1 §4",
  "welt.visualTitle": "Визуални учебни помагала",
  "welt.visualSubtitle":
    "Подпомагат разбирането – не променят съдържание, документи или PDF",
  "welt.questionsTitle": "Въпроси за проверка",
  "welt.questionsSubtitle":
    "{count} въпроса — самопроверка без отбелязване на верния отговор",
  "welt.maintenanceTitle": "Указания за проверка и поддръжка",
  "welt.maintenanceSubtitle": "Съгласно BetrSichV / UVV",
  "welt.performedBy": "Извършено от:",
  "welt.recommendedCheck": "Препоръчителна експертна проверка:",
  "welt.recurrenceTitle": "Цикли на повторение",
  "welt.recurrenceSubtitle": "За всеки модул – автоматично проследявано от системата",
  "welt.recurrenceUnterweisung": "Обучение",
  "welt.recurrenceGbuReview": "Оценка на риска – преглед",
  "welt.recurrenceWartung": "Поддръжка / проверка",
  "welt.recurrence.none": "–",
  "welt.recurrence.einmalig": "Еднократно",
  "welt.recurrence.monatlich": "Месечно",
  "welt.recurrence.vierteljaehrlich": "На тримесечие",
  "welt.recurrence.halbjaehrlich": "На шест месеца",
  "welt.recurrence.jaehrlich": "Годишно",
  "welt.recurrence.zwei_jahre": "На всеки 2 години",

  // Aufgaben-Status (StatusBadge)
  "status.offen": "Отворена",
  "status.erledigt": "Изпълнена",
  "status.ueberfaellig": "Просрочена",

  // Feste Abschnitts-Überschriften (content[].heading). Lookup-Schlüssel bleibt der
  // DEUTSCHE Quell-Heading; nur der WERT ist bulgarisch. DB/Beweiskette bleiben deutsch.
  "contentHeading.Worum geht es?": "За какво става въпрос?",
  "contentHeading.Welche Gefahren bestehen?": "Какви опасности съществуват?",
  "contentHeading.Vor Arbeitsbeginn beachten": "Какво да спазвате преди започване на работа",
  "contentHeading.Während der Arbeit beachten": "Какво да спазвате по време на работа",
  "contentHeading.Nach der Arbeit beachten": "Какво да спазвате след работа",

  // UI-/Präsentationslabels der visuellen Lernschicht (VLOs).
  "vlo.safetySymbols.title": "Знаци за безопасност",
  "vlo.safetySymbols.hint":
    "Тези знаци подпомагат обучението. Меродавен винаги е текстът.",
  "vlo.psaSummary.title": "Обобщение на ЛПС",
  "vlo.hazardMarkers.title": "Маркировки за опасност",
  "vlo.learningFocus.title": "Фокус на обучението",
  "vlo.richtigFalsch.title": "Правилно и грешно",
  "vlo.richtigFalsch.correct": "Правилно",
  "vlo.richtigFalsch.wrong": "Грешно",

  // PRINT.1 (Juni 2026) – етикети на плаката (UI елементи на отпечатания плакат).
  "plakat.eyebrow": "Инструктажен плакат",
  "plakat.subtitle": "Работете безопасно – най-важните правила накратко",
  "plakat.symbols": "Знаци за безопасност",
  "plakat.hazards": "Опасности",
  "plakat.richtigFalsch": "Правилно и грешно",
  "plakat.correct": "Правилно",
  "plakat.wrong": "Грешно",
  "plakat.psa": "Лични предпазни средства (ЛПС)",
  "plakat.rules": "Най-важните правила",
  "plakat.qrTitle": "Отворете света директно",
  "plakat.qrText": "Сканирайте QR кода с телефона, въведете PIN – този свят на документация се отваря веднага.",
  "plakat.footerHint": "Този плакат подпомага инструктажа. Меродавен остава пълният инструктаж.",
  "plakat.moreInFull": "Повече съдържание в пълния инструктаж",

  // AP-PLAKAT-UX (Juni 2026) – подзаглавия на групи + многостраничност.
  "plakat.hazardsSub": "Какво може да се случи?",
  "plakat.correctSub": "Как се работи безопасно.",
  "plakat.wrongSub": "Как не бива да се работи.",
  "plakat.continued": "продължение",
  "plakat.page": "Страница",
};

const bgExtra = {
  "aushang.linkTitle": "Закони и предписания, подлежащи на задължително обявяване",
  "aushang.linkSubtitle": "Официални оригинални текстове",
  "aushang.pageTitle": "Закони и предписания, подлежащи на задължително обявяване",
  "aushang.categoryAllgemein": "Общи правни основи",
  "aushang.categoryDguv": "Предписания DGUV и технически правила",

  "common.back": "Назад",
  "common.notEnabled": "Този изглед не е активиран за вашата фирма.",

  "aushang.kicker": "Задължително обявяване",
  "aushang.intro": "Връзки към официалните оригинални текстове. Операторът поддържа списъка централно; актуализациите се проверяват преди публикуване.",
  "aushang.loadError": "Списъкът не можа да бъде зареден.",
  "aushang.listLoading": "Зареждане…",
  "aushang.listEmpty": "Все още няма записи — операторът поддържа списъка чрез операторската конзола.",
  "aushang.categoryEmpty": "Няма записи в тази категория.",

  "hsp.kicker": "План за защита на ръцете",
  "hsp.titleFallback": "План за защита на кожата и ръцете",
  "hsp.loadError": "Планът за защита на ръцете не можа да бъде зареден.",
  "hsp.empty": "За тази работна зона в момента няма план за защита на ръцете.",
  "hsp.plakatCreatingTitle": "Плакатът се създава",
  "hsp.plakatCreatingText": "При първото отваряне се генерират изображенията — това може да отнеме до две минути. След това плакатът е достъпен веднага.",
  "hsp.plakatFailedTitle": "Плакатът не можа да бъде създаден.",
  "hsp.plakatFailedHint": "Моля, опитайте отново. Текстовият изглед е достъпен по-долу.",
  "hsp.plakatReload": "Плакатът не можа да бъде зареден. Моля, презаредете страницата.",
  "hsp.plakatTimeout": "Създаването отнема повече от очакваното. Моля, опитайте по-късно.",
  "hsp.plakatRetry": "Плакатът не можа да бъде създаден. Моля, опитайте отново.",
  "hsp.plakatLoadFailed": "Плакатът не можа да бъде зареден.",
  "hsp.plakatImgError": "Изображението на плаката не може да бъде показано.",
  "hsp.plakatAlt": "Плакат на плана за защита на ръцете",
  "hsp.plakatLoadingAria": "Плакатът се зарежда",
  "hsp.textOpen": "Покажи като текст",
  "hsp.textClose": "Затвори текстовия изглед",
  "hsp.thWas": "Какво",
  "hsp.thWann": "Кога",
  "hsp.thWomit": "С какво",
  "hsp.thWie": "Как",
  "hsp.firstAidTitle": "Първа помощ при контакт с кожата",
  "hsp.gsvOne": "1 опасно вещество в тази зона",
  "hsp.gsvMany": "Опасни вещества в тази зона: {count}",
  "hsp.gsvMenge": "Количество в предприятието:",
  "hsp.gsvHSaetze": "H-фрази:",
  "hsp.psaHandschutz": "Защита на ръцете",
  "hsp.psaAtemschutz": "Защита на дихателните пътища",
  "hsp.psaAugenschutz": "Защита на очите",
  "hsp.psaKoerperschutz": "Защита на тялото",
  "hsp.psaErsteHilfe": "Първа помощ при контакт с кожата",
  "hsp.psaAetzReiz": "Разяждащо/дразнещо действие",
  "hsp.psaSensibilisierung": "Сенсибилизация",
  "hsp.psaPSaetze": "P-фрази",

  "fuehrerschein.title": "Проверка на шофьорската книжка",
  "fuehrerschein.loadError": "Задачата не можа да бъде заредена.",
  "fuehrerschein.notApplicable": "В момента за вас не е предвидена проверка на шофьорската книжка.",
  "fuehrerschein.categoriesTitle": "Вашите видове превозни средства",
  "fuehrerschein.categoriesSubtitle": "Тези видове превозни средства е определил за вас работодателят.",
  "fuehrerschein.categoriesEmpty": "Няма зададени категории.",
  "fuehrerschein.upToDateTitle": "Шофьорската книжка е валидна",
  "fuehrerschein.upToDateText": "В момента не предстои проверка.",
  "fuehrerschein.nextDue": "Следваща проверка до",
  "fuehrerschein.lastDecision": "Последно одобрение:",
  "fuehrerschein.submittedTitle": "Успешно изпратено",
  "fuehrerschein.submittedText": "Снимката на книжката и декларацията са при работодателя за проверка.",
  "fuehrerschein.submittedAt": "Изпратено на",
  "fuehrerschein.declarationTitle": "Декларация",
  "fuehrerschein.declarationAccept": "Прочетох декларацията и я потвърждавам.",
  "fuehrerschein.photoFrontTitle": "Снимка на книжката: предна страна",
  "fuehrerschein.photoFrontHint": "Моля, снимайте четливо предната страна на книжката (видими име и срок на валидност).",
  "fuehrerschein.photoBackTitle": "Снимка на книжката: задна страна",
  "fuehrerschein.photoBackHint": "Моля, снимайте четливо задната страна на книжката (видима таблица с категориите).",
  "fuehrerschein.previewFrontAlt": "Преглед: предна страна",
  "fuehrerschein.previewBackAlt": "Преглед: задна страна",
  "fuehrerschein.otherPhoto": "Друга снимка",
  "fuehrerschein.remove": "Премахни",
  "fuehrerschein.pickFront": "Снимай предната страна или избери файл",
  "fuehrerschein.pickBack": "Снимай задната страна или избери файл",
  "fuehrerschein.pickLimits": "Макс. 12 MB · JPEG, PNG, WEBP, HEIC",
  "fuehrerschein.submit": "Изпрати",
  "fuehrerschein.submitting": "Изпращане…",
  "fuehrerschein.submitSuccess": "Успешно изпратено.",
  "fuehrerschein.submitFailed": "Изпращането не бе успешно. Моля, опитайте отново.",
  "fuehrerschein.errFormat": "Неподдържан формат на изображение. Моля, изберете JPEG, PNG, WEBP, HEIC или HEIF.",
  "fuehrerschein.errSize": "Файлът е твърде голям. Максимум: 12 MB.",
  "fuehrerschein.ocrPreparing": "Подготвя се автоматично разчитане…",
  "fuehrerschein.ocrUnavailable": "OCR временно недостъпен — моля, проверете книжката ръчно.",
  "fuehrerschein.ocrBannerStrong": "Автоматичен препис",
  "fuehrerschein.ocrBannerRest": " — без проверка от CLartext, не замества визуалния контрол.",
  "fuehrerschein.ocrName": "Име (разчетено)",
  "fuehrerschein.ocrExpiry": "Срок на валидност (разчетен)",
  "fuehrerschein.ocrClasses": "Категории (разчетени)",
};
Object.assign(bg, bgExtra);

export default bg;
